module.exports = __webpack_public_path__ + "img/list5.06df0072.png";